import { useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import SessionTimer from "./SessionTimer";
import { FaCopy } from "react-icons/fa6";
import { ToastContainer, toast } from "react-toastify";


function Commonheader() {
    const username = sessionStorage.getItem("user_name");
    const userId = sessionStorage.getItem("user_id");

    const [progress, setProgress] = useState(100);

    const handleLogout = () => {
        sessionStorage.clear();
        localStorage.clear();

        document.cookie.split(";").forEach(cookie => {
            document.cookie = cookie
                .replace(/^ +/, "")
                .replace(/=.*/, "=;expires=" + new Date(0).toUTCString() + ";path=/");
        });

        if ("caches" in window) {
            caches.keys().then(names => {
                names.forEach(name => caches.delete(name));
            });
        }

        window.history.pushState(null, "", window.location.href);
        window.onpopstate = () => window.history.go(1);
        window.location.replace("/");
    };
    const handleCopyUsername = () => {
        if (userId) {
            navigator.clipboard.writeText(userId);

            toast.success("User ID Copied Successfully", {
                theme: "colored",
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
            });

        }
    };



    return (
        <header className="top-header">
            <div className="par-logopart">
                <img src="../images/ap-logo.webp" alt="" className="img-fluid" />

                <div className="paralogo-text">
                    <p className="mb-0">State Project Directorate</p>
                    <p className="mb-0">Rashtriya Uchchatar Shiksha Abhiyan (RUSA)</p>
                    <h6>
                        Higher Education Department
                        Government of Andhra Pradesh
                    </h6>
                </div>

                <img src="../images/rusa-logo.webp" alt="" className="img-fluid rusa-logo" />
            </div>

            <div className="user-details">
                <div className="session-timer-container fancy-timer me-2">
                    <div className="timer-box">
                        <span className="timer-icon">⏳</span>
                        <span className="timer-text">
                            <SessionTimer
                                onLogout={handleLogout}
                                onProgress={setProgress}
                            />
                        </span>
                    </div>

                    <div className="progress-bar-container">
                        <div
                            className={`fancy-progress ${progress <= 25 ? "danger" : ""}`}
                            style={{ width: `${progress}%` }}
                        />
                    </div>
                </div>

                <div className="user-drop-down">
                    <div className="user-icon">
                        <img src="../images/user-img.svg" className="img-fluid" alt="user-img" />
                    </div>
                    {/* 
                    <Dropdown align="end">
                        <Dropdown.Toggle variant="success" >
                            Welcome :- {username}
                        </Dropdown.Toggle>

                        <Dropdown.Menu >
                            <Dropdown.Item onClick={handleCopyUsername}>  {userId}</Dropdown.Item>
                        </Dropdown.Menu>

                        <Dropdown.Menu>
                            <Dropdown.Item onClick={handleLogout}>
                                Logout
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown> */}
                    <Dropdown align="end">
                        <Dropdown.Toggle variant="success">
                            Welcome :- {username}
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            <Dropdown.Item onClick={handleCopyUsername}>
                                User ID : {userId}
                                <FaCopy style={{ marginLeft: "8px", cursor: "pointer" }} />
                            </Dropdown.Item>


                            <Dropdown.Divider />

                            {/* Logout */}
                            <Dropdown.Item onClick={handleLogout}>
                                Logout
                            </Dropdown.Item>

                        </Dropdown.Menu>
                    </Dropdown>
                    <ToastContainer />

                </div>
            </div>
        </header>
    );
}

export default Commonheader;
